module.exports = __webpack_public_path__ + "media/img/event/job-bottom-banner-a1950a2cb03cdaf415f85d266747bb53.jpeg";